
/**
 * Централизованная конфигурация Supabase URL
 * Заменяет жестко прописанные адреса на параметризованные
 */

// Получаем URL из переменных окружения или используем fallback
const getSupabaseUrl = (): string => {
  // Приоритет: переменная окружения -> fallback из config -> жестко прописанный
  return import.meta.env.VITE_SUPABASE_URL || 
         'https://syngo-tt-supabase-lk.tuk-tuk.rent';
};

const getSupabaseAnonKey = (): string => {
  return import.meta.env.VITE_SUPABASE_ANON_KEY || 
         'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVyd3podWR5aXRqb3ZzdHpxZmRqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQzMTMxNDgsImV4cCI6MjA1OTg4OTE0OH0.M5_8xZ0dVgZWONgztq8plbni81krGslzJwg5HSvR15k';
};

// Получаем bucket для логотипа из переменных окружения или используем fallback
const getLogoBucket = (): string => {
  return import.meta.env.VITE_LOGO_BUCKET || 'pics';
};

// Получаем bucket для документов из переменных окружения или используем fallback
const getDocumentsBucket = (): string => {
  return import.meta.env.VITE_DOCUMENTS_BUCKET || 'documents';
};

// Получаем URL отдельного хранилища документов из переменных окружения или используем fallback
const getDocumentsStorageUrl = (): string => {
  return import.meta.env.VITE_DOCUMENTS_STORAGE_URL || 
         'https://syngo-tt-supabase.tuk-tuk.rent/storage/v1/object/public/documents';
};

// Экспортируем конфигурацию
export const SUPABASE_URL = getSupabaseUrl();
export const SUPABASE_ANON_KEY = getSupabaseAnonKey();
export const LOGO_BUCKET = getLogoBucket();
export const DOCUMENTS_BUCKET = getDocumentsBucket();
export const DOCUMENTS_STORAGE_URL = getDocumentsStorageUrl();

// Утилиты для построения URL (сохраняем для обратной совместимости, но используем централизованные)
export const buildRestApiUrl = (endpoint: string): string => {
  return `${SUPABASE_URL}/rest/v1/${endpoint}`;
};

export const buildStorageUrl = (bucket: string, path: string): string => {
  return `${SUPABASE_URL}/storage/v1/object/public/${bucket}/${path}`;
};

// Специализированная функция для получения URL логотипа
export const buildLogoUrl = (filename: string = 'LOGO.svg'): string => {
  return buildStorageUrl(LOGO_BUCKET, filename);
};

// Для совместимости с существующим кодом
export const getSupabaseConfig = () => ({
  url: SUPABASE_URL,
  anonKey: SUPABASE_ANON_KEY,
  logoBucket: LOGO_BUCKET,
  documentsBucket: DOCUMENTS_BUCKET,
  documentsStorageUrl: DOCUMENTS_STORAGE_URL
});

console.log('✅ Централизованная конфигурация Supabase URL загружена:', SUPABASE_URL);
console.log('✅ Логотип будет загружаться из bucket:', LOGO_BUCKET);
console.log('✅ Документы будут загружаться из bucket:', DOCUMENTS_BUCKET);
console.log('✅ Хранилище документов:', DOCUMENTS_STORAGE_URL);
